export const iconMapper = status => {
    switch (status) {
        case 'SUBMITTED':
        case 'PENDING_SIGNATURE':
            return 'clock'
        case 'ACCEPTED':
            return 'check-circle'
        case 'REJECTED':
            return 'block'
    }
}

export const iconColorMapper = status => {
    switch (status) {
        case 'SUBMITTED':
            return 'warning'
        case 'ACCEPTED':
            return 'positive'
        case 'REJECTED':
            return 'negative'
        case 'PENDING_SIGNATURE':
            return 'warning'
    }
}

export const iconModalMapper = status => {
    switch (status) {
        case 'SUBMITTED':
        case 'PENDING_SIGNATURE':
            return 'clock'
        case 'ACCEPTED':
            return 'check-circle'
        case 'REJECTED':
            return 'block'
    }
}

export const colorStatusMapperModal = status => {
    switch (status) {
        case 'SUBMITTED':
        case 'PENDING_SIGNATURE':
            return 'var(--warning)' // pending
        case 'ACCEPTED':
            return 'var(--positive)' // accepted
        case 'REJECTED':
            return 'var(--negative)' // block
    }
}
